"use client";

import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

export function DatePager({
  label,
  hint,
  prevDate,
  nextDate,
  onChange,
  prevLabel = "Попередній навчальний день",
  nextLabel = "Наступний навчальний день",
}: {
  label: string;
  hint?: string | null;
  prevDate: string | null;
  nextDate: string | null;
  onChange: (date: string) => void;
  prevLabel?: string;
  nextLabel?: string;
}) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        className="flex size-10 shrink-0 items-center justify-center rounded-full bg-accent text-foreground disabled:opacity-30"
        disabled={!prevDate}
        aria-label={prevLabel}
        onClick={() => prevDate && onChange(prevDate)}
      >
        <ChevronLeftIcon className="size-5" />
      </button>
      <div className="min-w-0 flex-1 text-center">
        <p className="text-base font-semibold capitalize">{label}</p>
        {hint ? <p className="mt-0.5 line-clamp-2 text-[11px] leading-4 text-muted-foreground">{hint}</p> : null}
      </div>
      <button
        type="button"
        className="flex size-10 shrink-0 items-center justify-center rounded-full bg-accent text-foreground disabled:opacity-30"
        disabled={!nextDate}
        aria-label={nextLabel}
        onClick={() => nextDate && onChange(nextDate)}
      >
        <ChevronRightIcon className="size-5" />
      </button>
    </div>
  );
}
